import { Ban } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const CancelledOrderBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-destructive text-white">
      <Ban aria-hidden className="size-3 shrink-0" />
      {t('component:badge.cancelledOrder')}
    </Badge>
  );
};
